import baseRequest from '../baseRequest';
import AppConfig from '../../app/config/AppConfig';

class SubmitBenefitLeadForm extends baseRequest
{
    constructor(updateState) {
        super();
        this.name = 'SubmitBenefitLeadForm';
        this.dispatch = null;
        this.response = null;
        this.config = new AppConfig();
        this.updateState = updateState;
    }

    execute(dispatch, payload) {
        this.dispatch = dispatch;
        this.call(this.config.api.requests.submitBenefitLeadForm, payload);
    }

    onSuccess() {
        this.updateState(this.response.data);
    }
}

export default SubmitBenefitLeadForm;
